import { createFileRoute } from '@tanstack/react-router';
import ParentsPortal from '../../components/portals/ParentsPortal';
import { RequireRole } from '../../components/site/RequireRole';

export const Route = createFileRoute('/portal/parents')({
  component: ParentsPortalRoute,
});

function ParentsPortalRoute() {
  return (
    <RequireRole role="parent">
      <ParentsPortal />
    </RequireRole>
  );
}
